<template>
  <a-spin :spinning="loading">
      <a-row :gutter="[16,16]">
        <periodo-vacaciones
          :empleadoseleccionado="empleadoseleccionado"
          :contract="contract"
        />
      </a-row>
  </a-spin>
</template>
<script>
  export default {
    props: ['empleadoseleccionado', 'contract'],
    data () {
      return {
        loading: false,
        colSpan: {
          xs: 24,
          md: 8
        },
        fiOptions: {
          'wrapper-col': {
            offset: 8,
            span: 16
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/Vacaciones.vue